<template>
  <v-dialog persistent v-bind="[$attrs, $props]" width="488">
    <div class="px-7 pt-9 pb-8 white">
      <v-row>
        <v-col cols="12">
          <p class="primary--text font-weight-bold mb-0 text-h6">
            SEGURADORA CADASTRADA COM SUCESSO!
          </p>
          <p class="font-weight-medium darkBluishGray--text mb-12">
            Você deseja cadastrar uma nova seguradora?
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-spacer />
        <v-col cols="6" sm="3" class="pr-2">
          <BaseButton
            v-html="'NÃO'"
            color="secondary"
            outlined
            width="100%"
            @click="closeModal(false)"
          />
        </v-col>
        <v-col cols="6" sm="3">
          <BaseButton
            v-html="'SIM'"
            class="secondary"
            width="100%"
            @click="closeModal(true)"
          />
        </v-col>
      </v-row>
    </div>
  </v-dialog>
</template>
<script>
export default {
  methods: {
    closeModal(value) {
      this.$emit("close", value);
    }
  }
};
</script>
<style lang="sass"></style>
